import { render, staticRenderFns } from "./requestdelivery.vue?vue&type=template&id=0c99db9e&"
import script from "./requestdelivery.vue?vue&type=script&lang=js&"
export * from "./requestdelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports